import React, { useContext, useEffect, useRef, useState } from 'react';
import css from 'styled-jsx/css';
import MainLayout from 'components/layout/MainLayout';
import { ASSET_PREFIX } from 'utils/constants';
import PaddedMaxWidthContainer from 'components/layout/PaddedMaxWidthContainer';
import { getCookie, removeCookie } from 'utils/cookie';
import { OrderType } from 'components/payments/PayPalAdyenCheckout';
import ReferralLink from 'components/referrals/ReferralLink';
import HorizontalShard from 'components/HorizontalShard';
import RoundedButton from 'components/RoundedButton';
import NewRaffleTicket from 'components/iceland-raffle/NewRaffleTicket';
import { fetchLocaliteReferralThreshold } from 'api/bonus';
import { NextSeo } from 'next-seo';
import { getCurrentDraw, getRaffleTicketWithEntriesById } from 'api/raffle';
import Link from 'next/link';
import NextWinnerBanner from 'components/NextWinnerBanner';
import dayjs from 'dayjs';
import Calendar from 'dayjs/plugin/calendar';
import Subheading, { SubheadingColourScheme } from 'components/Subheading';
import {
  BackendSplitTest,
  getVariantForSplitTest,
  Referrals3Variant,
} from 'utils/SplitTesting';
import { useRouter } from 'next/router';
import ReferAndEarnSection from 'components/confirmation/ReferAndEarnSection';
import { RafflePrizeGroup } from 'components/raffle/RafflePrizeGroup';
import { fetchChristmasTravelRaffleRedemptionOption } from 'api/tokens';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { useAuthRedirect } from 'hooks/account/useAuthRedirect';
import { ITokenRedemptionOption } from 'types/Token';
import { IRaffleDraw, IRaffleTicket } from 'types/Raffle';
import { getCta } from 'utils/common';

const Confirmation = observer(
  () => (
    <div>
      {/* Christmas-travel-raffle confirmation is not implemented in DRIP */}
    </div>
  ),
  // const { currentUser, updateCurrentUser } = useUserStore();
  // const router = useRouter();
  // const isRedirecting = useRef<boolean>(false);
  // const orderId = router.query.orderId;

  // const [raffleTicket, setRaffleTicket] = useState<IRaffleTicket>();
  // const [referralThreshold, setReferralThreshold] = useState<number>();
  // const [currentPrize, setCurrentPrize] = useState<ITokenRedemptionOption>();
  // const [upcomingDraw, setUpcomingDraw] = useState<IRaffleDraw>();

  // useEffect(() => {
  //   const loadAsync = async () => {
  //     const jwt = await useAuthRedirect(router.pathname);

  //     const orderDetails = await getOrderDetails(
  //       jwt,
  //       orderId as any,
  //       OrderType.TOKEN_ORDER
  //     );

  //     const { raffleTicketWithEntries } = await getRaffleTicketWithEntriesById(
  //       jwt,
  //       orderDetails.order.raffle_ticket_id!
  //     );

  //     setRaffleTicket(raffleTicketWithEntries);

  //     const rtresp = await fetchLocaliteReferralThreshold(jwt);

  //     setReferralThreshold(rtresp.referralThreshold);

  //     const currentDraw = await getCurrentDraw(
  //       RafflePrizeGroup.LUCKYTRIP_CHRISTMAS_TRAVEL
  //     );

  //     setUpcomingDraw(currentDraw);

  //     const tokenRedemptionOption =
  //       await fetchChristmasTravelRaffleRedemptionOption();

  //     setCurrentPrize(tokenRedemptionOption);
  //   };

  //   loadAsync();
  // }, [orderId]);

  // const drawDate = upcomingDraw && new Date(upcomingDraw.draw_date);

  // dayjs.extend(Calendar);
  // const formattedDrawDateString = dayjs(upcomingDraw?.draw_date).format(
  //   "D/MM/YYYY [at] h[pm]"
  // );

  // const raffleTicketLines = raffleTicket?.entries;

  // const [loadingSplitTestVariant, setLoadingSplitTestVariant] = useState(true);
  // const [referralBonusScheme, setReferralBonusScheme] = useState<string>();

  // // Fetch Referrals3 split test variant (if any).
  // const fetchReferrals3Variant = async (overrideReferrals3Variant?: string) => {
  //   const variant =
  //     overrideReferrals3Variant ??
  //     (await getVariantForSplitTest(currentUser, BackendSplitTest.Referrals3));
  //   if (variant) {
  //     setReferralBonusScheme(variant);
  //   }
  //   return variant ?? null;
  // };

  // useEffect(() => {
  //   (async () => {
  //     await fetchReferrals3Variant(
  //       router?.query?.overrideReferrals3Variant as string
  //     );
  //     setLoadingSplitTestVariant(false);
  //   })();
  // }, [router?.query]);

  // useEffect(() => {
  //   removeCookie("referral_id");
  //   removeCookie("Affc");

  //   // Fetch current user again so get updated tree count, leaderboard points, and to give the upgrade now banner.
  //   updateCurrentUser(getCookie('jwt'))
  //   // Unbounce conversion tracking code.
  //   // @ts-ignore: Unbounce conversion tracking code
  //   var _ubaq = _ubaq || [];
  //   _ubaq.push(["trackGoal", "convert"]);
  //   // @ts-ignore: Unbounce conversion tracking code
  //   window._ubaq = _ubaq;
  //   (function () {
  //     var ub_script = document.createElement("script");
  //     ub_script.type = "text/javascript";
  //     ub_script.src =
  //       ("https:" === document.location.protocol ? "https://" : "http://") +
  //       "d3pkntwtp2ukl5.cloudfront.net/uba.js";
  //     var s = document.getElementsByTagName("script")[0];
  //     // @ts-ignore: Unbounce conversion tracking code
  //     s.parentNode.insertBefore(ub_script, s);
  //   })();
  // }, []);

  // return (
  //   <MainLayout>
  //     <NextSeo
  //       title="Christmas Travel Raffle Confirmation | Win Epic Prizes | DAYMADE"
  //       openGraph={{
  //         title:
  //           'Christmas Travel Raffle Confirmation | Win Epic Prizes | DAYMADE',
  //       }}
  //     />

  //     {drawDate && (
  //       <div className="bannerContainer">
  //         <NextWinnerBanner
  //           showUpcomingDrawDate={true}
  //           heading={
  //             <>
  //               Next <strong>Winner</strong> In
  //             </>
  //           }
  //         />
  //       </div>
  //     )}

  //     <img
  //       src={currentPrize?.heroImage}
  //       className="heroImage"
  //     />

  //     <div id="titleSection">
  //       <PaddedMaxWidthContainer style={{ marginTop: '20px' }}>
  //         <img
  //           src={`${ASSET_PREFIX}/images/confirmation/champagne.svg`}
  //           alt=""
  //           width="65px"
  //         />
  //         <Subheading Tag="h1">
  //           You're <strong>In</strong>!
  //         </Subheading>
  //       </PaddedMaxWidthContainer>
  //     </div>

  //     <div id="ticketSection">
  //       <PaddedMaxWidthContainer
  //         style={{ marginBottom: '40px', textAlign: 'center' }}
  //       >
  //         {raffleTicketLines && raffleTicketLines?.length > 1 ? (
  //           <p style={{ marginBottom: 0 }}>And here are your entries</p>
  //         ) : (
  //           raffleTicketLines?.length === 1 && (
  //             <p style={{ marginBottom: 0 }}>And here is your entry</p>
  //           )
  //         )}

  //         {raffleTicket && raffleTicketLines && (
  //           <NewRaffleTicket
  //             rafflePrizeGroup={raffleTicket.prize_group}
  //             lines={raffleTicketLines}
  //           />
  //         )}

  //         {formattedDrawDateString && (
  //           <p style={{ marginTop: '1.5em' }}>
  //             The draw will take place on{' '}
  //             <strong>{formattedDrawDateString}</strong>.
  //           </p>
  //         )}

  //         <p>
  //           <i>
  //             We’ve also emailed your entries over to you so keep an eye on your
  //             inbox!
  //           </i>
  //         </p>
  //       </PaddedMaxWidthContainer>
  //     </div>

  //     {referralBonusScheme === Referrals3Variant.GIVE_6_GET_6 && (
  //       <ReferAndEarnSection />
  //     )}

  //     <PaddedMaxWidthContainer
  //       wavyBackground
  //       style={{ marginTop: '20px', marginBottom: '70px' }}
  //     >
  //       {!loadingSplitTestVariant &&
  //         referralBonusScheme &&
  //         referralBonusScheme !== Referrals3Variant.GIVE_6_GET_6 && (
  //           <>
  //             <div className="iconBlock">
  //               <img
  //                 src={`${ASSET_PREFIX}/images/free-subscription-confirmation/freebie-icon-grey-green.svg`}
  //                 className="icon"
  //                 alt=""
  //               />

  //               <h3>
  //                 Fancy A <b>Freebie?</b>
  //               </h3>
  //             </div>

  //             <div className="card">
  //               {referralThreshold === 2 ? (
  //                 <>
  //                   Invite 2 friends. If they both get a paid subscription,
  //                   you'll get a <strong>free Bronze prize</strong> of choice.
  //                 </>
  //               ) : (
  //                 <>
  //                   Invite 3 friends. If they all pay to enter, you'll get a{' '}
  //                   <strong>free Bronze prize</strong> of choice.
  //                   <br />
  //                   <br />
  //                   They'll also get 30% off their 1st purchase!
  //                 </>
  //               )}
  //               <ReferralLink style={{ marginTop: '1em' }} />
  //             </div>
  //           </>
  //         )}

  //       <div className="iconBlock">
  //         <img
  //           className="icon"
  //           src={`${ASSET_PREFIX}/images/landing/trophy.svg`}
  //           alt=""
  //         />
  //         <h3>
  //           The <b>winner</b>
  //         </h3>
  //       </div>

  //       <div className="card">
  //         <p>
  //           The GUARANTEED winner will be drawn {formattedDrawDateString}.
  //           Results will be posted {''}
  //           <Link href="/results?tab=pound-raffle">
  //             <a style={{ textDecoration: 'underline' }}>here</a>
  //           </Link>
  //           {''} and the winner will be emailed immediately.
  //         </p>
  //         <p>
  //           <b>All entrants will be emailed with the results.</b>
  //         </p>
  //       </div>
  //     </PaddedMaxWidthContainer>

  //     <HorizontalShard
  //       background={`${ASSET_PREFIX}/images/daily-pound-raffle/confirmation/green-background.svg`}
  //       topLeftInset={0}
  //       topRightInset={7}
  //       bottomRightInset={0}
  //       bottomLeftInset={0}
  //       style={{
  //         marginTop: '-65px',
  //         backgroundPosition: 'center',
  //         padding: '2em',
  //         display: 'flex',
  //         flexDirection: 'column',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //       }}
  //     >
  //       <div
  //         className="paddedMaxWidthContainer"
  //         id="weeklyDrawSection"
  //       >
  //         <div style={{ position: 'relative', width: '100%' }}>
  //           <div className="iconBlock">
  //             <img
  //               className="icon"
  //               src={`${ASSET_PREFIX}/images/iceland-raffle/weekly-draw-icon.svg`}
  //               alt=""
  //               width="50px"
  //             />
  //             <p>
  //               <i>Check out our</i>
  //             </p>
  //             <Subheading
  //               colourScheme={SubheadingColourScheme.GREY_TEXT_WHITE_SHADOW}
  //               style={{ marginTop: 0 }}
  //             >
  //               Weekly <strong>Draws</strong>
  //             </Subheading>
  //           </div>
  //         </div>

  //         <div id="weeklyDrawImages">
  //           <div style={{ display: 'flex' }}>
  //             <div className="weeklyDrawImageBlock">
  //               <img
  //                 src={`${ASSET_PREFIX}/images/iceland-raffle/live-draw.jpg`}
  //                 alt="Draws every Tuesday & Friday"
  //               />
  //               <p>Draws every Tuesday & Friday</p>
  //             </div>

  //             <div className="weeklyDrawImageBlock">
  //               <img
  //                 src={`${ASSET_PREFIX}/images/iceland-raffle/plant-a-tree.jpg`}
  //                 alt="Plant a tree with every purchase"
  //               />
  //               <p>Plant a tree with every purchase</p>
  //             </div>
  //           </div>

  //           <div style={{ display: 'flex' }}>
  //             <div className="weeklyDrawImageBlock">
  //               <img
  //                 src={`${ASSET_PREFIX}/images/iceland-raffle/winners.jpg`}
  //                 alt="Hundreds of winners every week"
  //               />
  //               <p>100s of winners every week</p>
  //             </div>

  //             <div className="weeklyDrawImageBlock">
  //               <img
  //                 src={`${ASSET_PREFIX}/images/iceland-raffle/epic-prizes.jpg`}
  //                 alt="More than 100 epic prizes"
  //               />
  //               <p>250+ EPIC prizes</p>
  //             </div>
  //           </div>
  //         </div>

  //         <RoundedButton
  //           id="copyButton"
  //           href={getCta()?.url}
  //           style={{
  //             padding: '10px 18px',
  //             margin: '2em 0',
  //             minWidth: '250px',
  //             fontWeight: '600',
  //             fontSize: '14px',
  //           }}
  //         >
  //           Enter For £2.95
  //         </RoundedButton>
  //       </div>
  //     </HorizontalShard>

  //     <style jsx>{styles}</style>
  //   </MainLayout>
  // );
);

const styles = css`
  .bannerContainer {
    position: absolute;
    top: 110px;
    right: 0;
    left: 0;
    background: linear-gradient(
      to bottom,
      rgba(176, 176, 176, 1),
      rgba(176, 176, 176, 0.7) 60%,
      rgba(176, 176, 176, 0)
    );
  }

  .heroImage {
    width: 100%;
    height: 600px;
    object-fit: cover;
    object-position: 50% 65%;
  }

  .weeklyDrawImageBlock p {
    margin-top: 0.5em;
  }

  @media (max-width: 800px) {
    .heroImage {
      height: 450px;
    }
  }

  @media (max-width: 415px) {
    .heroImage {
      height: 350px;
      object-position: 50% 50%;
    }
  }

  a {
    font-weight: bold;
  }

  #titleSection {
    display: flex;
    justify-content: center;
    width: 100%;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 30%
    );
    position: relative;
    margin-top: -145px;
    padding-top: 4em;
  }

  #ticketSection {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .discountBlock {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: url(${ASSET_PREFIX}/images/iceland-raffle/speech-bubble.png);
    background-size: cover;
    color: white;
    width: 102px;
    height: 95px;
    padding-bottom: 5px;
  }

  .discountBlock .text {
    font-weight: 600;
    font-size: 15px;
    line-height: 8px;
  }

  .discountBlock .largeText {
    font-weight: 600;
    font-size: 20px;
  }

  @media (min-width: 515px) {
    .discountBlock {
      left: 12%;
      width: 122px;
      height: 114px;
    }
  }

  @media (min-width: 1032px) {
    .discountBlock {
      top: 1em;
      width: 142px;
      height: 133px;
    }

    .discountBlock .text {
      font-size: 18px;
      line-height: 16px;
    }

    .discountBlock .largeText {
      font-size: 25px;
    }
  }

  .iconBlock {
    margin: 3em 0 0.5em;
    text-align: center;
  }

  .iconBlock .icon {
    margin: 5px;
    width: 60px;
  }

  .iconBlock h3 {
    margin: 10px 0;
  }

  .iconBlock p {
    margin: 10px 0;
    font-size: 14px;
  }

  .card {
    background-color: white;
    padding: 2em 1em;
    box-shadow: 0 1px 4px 3px rgba(55, 55, 55, 0.2);
    border-radius: 5px;
    font-size: 1.2em;
    font-weight: 600;
    width: 100%;
    max-width: 450px;
    text-align: center;
    margin: 0.5em 0 2em;
  }

  @media (min-width: 450px) {
    .card {
      padding: 2em;
    }
  }

  #weeklyDrawSection {
    width: 100%;
  }

  #weeklyDrawImages {
    display: flex;
    width: 100%;
    margin: 2em 0 1em;
    flex-wrap: wrap;
    justify-content: center;
  }

  .weeklyDrawImageBlock {
    margin: 2em;
    width: 120px;
    text-align: center;
  }

  .weeklyDrawImageBlock img {
    width: 100px;
    border-radius: 100%;
  }

  #weeklyDrawImages p {
    font-size: 1.1em;
  }

  #inviteLink {
    font-size: 13px;
    display: flex;
    align-items: center;
    text-align: center;
    border: 2px solid #9b9b9b;
    border-radius: 5px;
    padding: 0.4em 1em;
    margin: 0em auto 0 auto;
    overflow-x: auto;
    white-space: nowrap;
    font-weight: bold;
    flex-shrink: 0;
    background-color: white;
  }

  @media (min-width: 595px) {
    .weeklyDrawImageBlock {
      margin: 2em 4em;
      width: 150px;
    }

    .weeklyDrawImageBlock img {
      width: 130px;
    }
  }

  :global(.footer) {
    margin-top: 0 !important;
  }
`;

export default Confirmation;
